// [2026-10-25] เรียก API ที่หลายส่วนใช้ร่วมกัน "ครั้งเดียว" แล้วแบ่งผลกัน
//   เดิม: main.js, footer.js, navmenu.js, register.js, profile.js ... ต่างคนต่างยิง /mainsetting เอง
//         banner.js ถูกวางไว้ 3 จุด → /tabbannerlist 3 ครั้งพร้อมกัน, /cacheversion ยิงซ้อนกันตอนเปิดเว็บ
//   ตอนนี้: ยิงพร้อมกันกี่ที่ก็ได้ → ใช้ request เดียวกัน (in-flight) + จำผลไว้ช่วงสั้น ๆ (memory)
//   ผลที่คืนเป็นรูปแบบเดียวกับ axios ({ data }) → โค้ดเดิม .then((res) => res.data...) ใช้ต่อได้เลย
import instance from './axios-instance';
import Systems from './SystemFunction';
import jwt_decode from 'jwt-decode';

const inflight = {};
const mem = {};

// POST ที่ body เหมือนกัน → request เดียว + จำผลไว้ ttl ms (เฉพาะ status 200)
export function sharedPost(url, body, ttl) {
  const key = url + '|' + JSON.stringify(body || {});
  const hit = mem[key];
  if (hit && Date.now() - hit.ts < (ttl || 0)) return Promise.resolve(hit.res);
  if (inflight[key]) return inflight[key];
  inflight[key] = instance.post(url, body)
    .then((res) => {
      if (res && res.data && res.data.status === 200) mem[key] = { ts: Date.now(), res };
      return res;
    })
    .finally(() => { delete inflight[key]; });
  return inflight[key];
}

// ---------- /cacheversion ----------
let _ver = null, _verTs = 0, _verP = null;
export function getCacheVersion() {
  if (_ver !== null && Date.now() - _verTs < 60 * 1000) return Promise.resolve(_ver);
  if (_verP) return _verP;
  _verP = instance.get('/api/v1/cacheversion', { params: { System: Systems } })
    .then((response) => {
      _ver = response.data.message.versionCaching;
      _verTs = Date.now();
      return _ver;
    })
    .catch(() => null)
    .finally(() => { _verP = null; });
  return _verP;
}

// ---------- /mainsetting ----------
const MAINSETTING_TTL = 5 * 60 * 1000; // เท่ากับ main.js
export function currentPlayerid() {
  try {
    const t = localStorage.getItem('auth_token');
    if (!t) return null;
    const d = jwt_decode(t);
    return (d && d.message && d.message.playerid) || null;
  } catch (e) { return null; }
}
// ยิงจริง (รวม request ที่ซ้อนกัน) — Playerid มีผลกับลิงก์ไลน์ตามกลุ่มสมาชิก
export function getMainSetting(Playerid) {
  const body = { System: Systems };
  if (Playerid !== undefined && Playerid !== null) body.Playerid = Playerid;
  return sharedPost('/api/v1/mainsetting', body, MAINSETTING_TTL);
}
// ส่วนประกอบรอง (footer, เมนู, หน้าสมัคร ...) — ใช้ cache เดียวกับ main.js (localStorage "mainSettingCache") ถ้า version ตรง
//   ไม่งั้นยิงผ่าน getMainSetting (ร่วม request กับ main.js)
export async function getMainSettingCached() {
  const Playerid = currentPlayerid();
  try {
    const version = await getCacheVersion();
    const c = JSON.parse(localStorage.getItem('mainSettingCache') || 'null');
    if (c && c.data && Date.now() - c.timestamp < MAINSETTING_TTL && c.data.version === version && c.data.data) {
      return { data: c.data.data, cached: true };
    }
  } catch (e) { /* ใช้ API */ }
  return getMainSetting(Playerid);
}
